<template>
  <gj-select
      v-bind="$attrs"
      v-on="$listeners"
      :options="serverOption"
      :placeholder="placeholder"
      :width="width"
  ></gj-select>
</template>

<script>
  import {mapGetters} from "vuex";
  import {isMeaningful} from "@/utils/common";

  export default {
    name: "gj-account-select",
    props: {
      placeholder: {
        type: String,
        default: '全部账号'
      },
      width: {
        type: String,
        default: '150px'
      }
    },
    computed: {
      ...mapGetters({
        markets: 'markets'
      }),
      serverOption() {
        if (isMeaningful(this.markets)) {
          const accountMarkets = this._.groupBy(this.markets, (item) => item.text);
          return this._.uniqBy(this.markets, (item) => item.text).map((item, index) => ({
            ...item,
            id: index,
            marketIds: accountMarkets[item.text]
          }))
        }
        return [];
      }
    }
  }
</script>

<style scoped>

</style>






